module.exports = __webpack_public_path__ + "img/banner-25.a47593fc.jpg";